export const init = () => {
  const icon = cube.$id('js-remember-me-tooltip-icon');
  const closeButton = cube.$id('js-remember-me-tooltip-close-button');

  icon.on('click', toggleTooltip);
  closeButton.on('click', () => icon.dispatchEvent(new CustomEvent('click')));
};


/**
 * Display or hide the remember me tooltip.
 *
 * @param {Event} event
 */
function toggleTooltip (event) {
  event.preventDefault();

  const offset = this.offsetLeft;
  const tooltip = cube.$id('js-remember-me-tooltip');
  const { classList } = tooltip;

  tooltip.style.setProperty('--arrow-offset-left', `${ offset }px`);

  if (classList.contains('account-tooltip-v2--hidden'))
    classList.remove('account-tooltip-v2--hidden');
  else
    classList.add('account-tooltip-v2--hidden');
};


// WEBPACK FOOTER //
// ./src/customer/create-account/create-account-tooltip.js